<template>
  <div>
    <generic-modal
      v-if="showMyAddressModal"
      :height="myAddressModalDim.height"
      :width="myAddressModalDim.width"
      :modalClass="[
        checkIsCartDestination()
          ? 'full-screen-popup lg-screen-centered my-address-modal-container cart-my-address'
          : 'full-screen-popup lg-screen-centered my-address-modal-container',
      ]"
      :contentScroll="false"
      :dependentComputedProps="{
        showMyAddressModal,
      }"
      :animationStyle="[
        checkIsCartDestination() ? 'slide-up-stick-bottom' : '',
      ]"
    >
      <template v-slot:header>
        <div
          v-if="clientPlatform == 'Web' && isOnAddressPage"
          class="dt-header"
        >
          <hongs-logo class="dt-header-logo"></hongs-logo>
        </div>
        <div class="static-pg-header" v-else-if="!checkIsCartDestination()">
          <i
            class="hkfi-back dt-hand"
            v-on:click="closeMyAddressModal($event, 'back')"
          ></i>
          <span class="title">My Address</span>
        </div>
        <div class="header-cart-addr" v-else>
          <div class="handle"></div>
          <i
            class="hkfi-close fs-22"
            v-on:click="closeMyAddressModal($event, 'close')"
          ></i>
        </div>
      </template>
      <template v-slot:body>
        <div class="addr-body" v-if="savedAddresses?.length > 0">
          <div class="color-slaty-dark bold fs-16 mb16" v-if="isOnCartPage">
            Select a Saved Address
          </div>
          <div class="add-addr-btn lh14 fs-14 medium">
            <button v-on:click="handleAddAddress()">
              <i class="hkfi-plus"></i>Add New Address
            </button>
          </div>
          <reusable-list
            v-if="savedAddresses.length > 0"
            :items="savedAddresses"
            :editableMenuItems="
              isLoggedIn
                ? editableSavedAdressMenuItems
                : editableSavedAdressMenuItemsForGuestUser
            "
            :mainTextKey="SavedAddressesListKeys.mainTextKey"
            :subTextKey="SavedAddressesListKeys.subTextKey"
            :itemIconKey="SavedAddressesListKeys.itemIconKey"
            :listTitle="SavedAddressesListKeys.listTitle"
            :displayEditableIconMenu="false"
            :listType="checkIsCartDestination() ? 'savedAddresses' : ''"
            :radioBtnEnable="[checkIsCartDestination() ? false : true]"
            :onClick="handleListItemClick"
            :radioBtnMethod="radioSelectMethod"
            :listName="'addresses'"
            :className="'search_lst_web'"
          />
        </div>
        <div class="no-addr" v-else-if="!isLoading">
          <div class="no-addr-icon-body">
            <div class="no-addr-image">
              <img :src="NoAddressImage" />
            </div>
          </div>
          <div class="fs-16 bold title lh21">Uh-Oh this looks empty!</div>
          <div class="text fs-14 lh21">
            Add your address to enjoy quick & hassle-free delivery.
          </div>
          <div class="no-addr-add-addr-btn lh24 fs-16 bold">
            <button v-on:click="handleAddAddress()">Add Address</button>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div
          class="cart-addr-footer"
          v-if="checkIsCartDestination() && savedAddresses?.length > 0"
        >
          <button
            class="cnfrm-btn fs-14 bold"
            :class="[this.showCartConfirmAddress ? 'enable' : 'disable']"
            v-on:click="confirmAddressMethod"
          >
            Confirm Address
          </button>
        </div>
      </template>
    </generic-modal>
    <generic-modal
      v-if="showDeleteModal"
      @close="closeDeleteModal()"
      :height="deleteAddressModalDim.height"
      :width="deleteAddressModalDim.width"
      :modalClass="deleteAddressModalDim.modalClass"
      :bottom="deleteAddressModalDim.bottom"
      :paddingBottom="deleteAddressModalDim.paddingBottom"
    >
      <template v-slot:header></template>
      <template v-slot:body>
        <div class>
          <div class="header fs-16 bold pt16">Delete Address</div>
          <div class="content fs-14">
            Please confirm, you want to delete the saved address.
          </div>
          <div class="btns">
            <button class="cancel fs-14 medium" v-on:click="closeDeleteModal()">
              Cancel
            </button>
            <button class="delete fs-14 medium" v-on:click="confirmDelete()">
              Yes, Delete
            </button>
          </div>
        </div>
      </template>
      <template v-slot:footer></template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import ReusableList from "./ReusableList.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../helpers/storeKeys";
import { SavedAddressesListKeys } from "../helpers/addressConstants";
import HongsLogo from "./HongsLogo.vue";
import Utility from "../helpers/utility";
import NoAddressImage from "../../../default/images/global/img-no-address.png";
import {
  imgBaseUrl,
  staticImgBaseUrl,
  googleApiEndpoints,
  clientPlatform,
} from "../config/apiEndpoints";
import { load } from "../helpers/landingUtils";

export default {
  name: "MyAddressModal",
  props: {
    destination: {
      required: false,
      default: "",
    },
  },
  components: {
    GenericModal,
    ReusableList,
    HongsLogo,
  },
  data() {
    return {
      myAddressModalDim: {
        height: "100vh",
        width: "100%",
      },
      deleteAddressModalDim: {
        width: "281px",
        height: "fit-content",
        modalClass: "delete-address-modal",
      },
      SavedAddressesListKeys,
      showDeleteModal: false,
      deleteAddressId: "",
      addressItem: {},
      showCartConfirmAddress: false,
      addressSelected: {},
      NoAddressImage,
      staticImgBaseUrl,
      clientPlatform,
    };
  },
  mounted() {
    //this.apiCallsForUser();
    Utility.checkFromAddressPage();
    this.apiCallsForUser();
    if (!this.checkIsCartDestination()) {
      this.$store.commit(keyMapsMutation.SHOW_MY_ADDRESS_MODAL, true);
    }
    Utility.removeAddEditAddressFromStorage();
    if (typeof window.google === "undefined") {
      load(googleApiEndpoints.MAP_URL);
    }
    this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true);
    setTimeout(
      () => this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false),
      3000
    );
  },
  methods: {
    apiCallsForUser() {
      this.$store.dispatch(keyMapsAction.SAVED_ADDRESSES_API);
      // if (LocalStorageFunc.isLoggedIn()) {
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_SAVED_ADDRESSESS,
      //   Utility.tryJsonParse(JSON.stringify(SavedAddressessData?.data)))
      //} else {
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_SAVED_ADDRESSESS,
      //   Utility.tryJsonParse(JSON.stringify(SavedAddressessData?.data))
      // );
      //this.$store.commit(keyMapsMutation.SHOW_MY_ADDRESS_MODAL, true);
      // }
      //@todo:- remove this after stable flow, this if for testing only
      //this.$store.commit(keyMapsMutation.UPDATE_SAVED_ADDRESSESS, SavedAddressessData?.data);
      //this.$store.commit(keyMapsMutation.SHOW_MY_ADDRESS_MODAL, true);
    },
    closeMyAddressModal(event, type = "") {
      //console.log("close clicked")
      if (type == "back") {
        Utility.redirectToHomeOrRedirectUrl();
      }
      this.$store.commit(keyMapsMutation.SHOW_MY_ADDRESS_MODAL, false);
    },
    handleEditClick(item) {
      LocalStorageFunc.setEditAddresEnable(item);
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
      LocalStorageFunc.deleteLocationChangedAddress();
      Utility.sendToLocationScreen(window.location);
    },
    handleDeleteClick(item) {
      this.deleteAddressId = item?.address_id;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    confirmDelete() {
      //@todo delete method for address
      this.$store.dispatch(keyMapsAction.DELETE_ADDRESS_API, {
        addressId: this.deleteAddressId,
      });
      //this.$store.dispatch(keyMapsAction.DELETE_ADDRESS_API,{addressId: this.deleteAddressId})
      this.$store.dispatch(keyMapsAction.DELETE_ADDRESS_API, {
        addressId: this.deleteAddressId,
      });
      this.closeDeleteModal();
    },
    handleAddAddress() {
      LocalStorageFunc.setAddAddressEnable();
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
      Utility.sendToLocationScreen(window.location);
    },
    checkIsCartDestination() {
      //console.log('isCart',this.destination == 'cart');
      return this.destination == "cart";
    },
    cartAddressSelectMethod(address) {
      this.showCartConfirmAddress = true;
      this.addressSelected = address;
    },
    confirmAddressMethod() {
      if (this.showCartConfirmAddress) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
          this.addressSelected
        );
        let pos = {
          lat: this.addressSelected.latitude,
          lng: this.addressSelected.longitude,
        };
        let position = {
          coords: {
            latitude: pos.lat,
            longitude: pos.lng,
          },
          homePageAddress: {
            topAddress: this.addressSelected.customer_address_name,
            bottomAddress: this.addressSelected.formatted_address,
          },
        };
        this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos);
        this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, position);
        this.$store.commit(keyMapsMutation.SHOW_MY_ADDRESS_MODAL, false);
        this.$store.dispatch(keyMapsAction.CREATE_CART_ITEMS_API, {});
      }
    },
    handleListItemClick(item) {
      document.body.classList.remove("hide-header-footer");
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS, item);
      LocalStorageFunc.setLocalStorageValue("selectedAddress", item);
      let pos = {
        lat: item.latitude,
        lng: item.longitude,
      };
      let position = {
        coords: {
          latitude: pos.lat,
          longitude: pos.lng,
        },
        redirectTo: Utility.redirectToHomeOrRedirectUrl,
        homePageAddress: {
          topAddress: item.customer_address_name,
          bottomAddress: item.formatted_address,
        },
      };
      this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos);
      this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, position);
    },
  },
  computed: {
    savedAddresses() {
      //return SavedAddressessData?.data;
      return this.$store.getters[keyMapsGetter.GET_REARRANGED_SAVED_ADDRESS]();
    },
    editableSavedAdressMenuItemsForGuestUser() {
      return [
        {
          label: "Edit",
          labelMethod: (item) => {
            this.handleEditClick(item);
          },
        },
      ];
    },
    editableSavedAdressMenuItems() {
      return [
        {
          label: "Edit",
          labelMethod: (item) => {
            this.handleEditClick(item);
          },
        },
        {
          label: "Remove",
          labelMethod: (item) => {
            this.handleDeleteClick(item);
          },
        },
      ];
    },
    radioSelectMethod() {
      if (this.checkIsCartDestination()) {
        return {
          radioMethod: (address) => {
            this.cartAddressSelectMethod(address);
          },
        };
      } else {
        return {
          radioMethod: (address) => {},
        };
      }
    },
    showMyAddressModal() {
      //console.log("my-address-2", this.$store.state.User.showMyAddressModal);
      return this.$store.state.User.showMyAddressModal;
    },
    isOnCartPage() {
      return Utility.isCurrentlyAtUrl("/cart");
    },
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    isLoading() {
      return this.$store.state.Loader.isLoading;
    },
    isOnAddressPage() {
      return Utility.isCurrentlyAtUrl("/my-addresses");
    },
  },
};
</script>

<style></style>
